import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import vhCheck from 'vh-check';
import { Router } from './Router';
import { PromptToInstallProvider } from './Contexts/PromptToInstallContext';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

vhCheck();

const App: FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        document.title = t('AppTitle');
    }, [t]);

    library.add(fas);

    return (
        <PromptToInstallProvider>
            <Router />
        </PromptToInstallProvider>
    );
};

export default App;
